




import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Gradientbackground extends Vue {

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/gradient-background.vue